import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const Users = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          {/*
                       <Grid item xs={2}><h3>Example Request</h3></Grid>
                      <Grid item xs={10}>
                      <pre className={classes.pre}>
                      <code>
                    </code>
                      </pre>
                      </Grid>
                      */}
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
	"users": [{
			"id": 100001,
			"uuid": "457deb3a-aa64-4488-96af-cfee2c77b6ac",
			"partnerId": 1,
			"partnerUserId": "abc123",
			"accessCode": null,
			"email": "example@dietid.com",
			"username": "example_username_123",
			"firstName": "Test",
			"lastName": "Ing",
			"workflowShareUrl": null,
			"createdAt": "2022-04-07T14:42:57.278Z",
			"lastWorkflow": null,
			"lastType": null,
			"lastQuality": null,
			"challengeSubscriptions": null,
			"userRole": "",
			"signupMeta": {
				"health_goals": [
					"control_bp",
					"manage_weight",
					"improve_gut_health",
					"manage_high_cholesterol"
				]
			},
			"preAndPost": {}
		},
		{
			"id": 100002,
			"uuid": "257deb3a-aa64-4488-96af-cfee2c77b6ac",
			"partnerId": 2,
			"partnerUserId": "789xyz",
			"accessCode": null,
			"email": "example2@dietid.com",
			"username": "example_username_789",
			"firstName": "Dev",
			"lastName": "Test",
			"workflowShareUrl": null,
			"createdAt": "2022-04-07T14:42:57.278Z",
			"lastWorkflow": null,
			"lastType": null,
			"lastQuality": null,
			"challengeSubscriptions": null,
			"userRole": "",
			"signupMeta": {
				"health_goals": [
					"improve_overall",
					"reduce_cardio_risk",
					"decrease_inflammation",
					"manage_food_sensitivities"
				]
			},
			"preAndPost": {}
		}
	]
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <Users />
    </React.Suspense>
  );
};
export default Wrapper;
